import { useSelector } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { selectAccountId } from '../redux/reducers/account/account';
import { accountRoutes } from '../constants/routes';
import { addLangPrefix } from '../components/common/buttons/Link';
import TokenService from '../services/network/tokenService';

export const RequireAuth = ({ children }) => {
    const accountId = useSelector(selectAccountId);
    const location = useLocation();
    const { lang } = useParams();

    if (accountId) return children;

    if (typeof window !== 'undefined') {
        try {
            const hasAccessToken = !!TokenService.getAccessToken();
            const hasStoredAccountId = !!window.localStorage.getItem('accountId');
            if (hasAccessToken || hasStoredAccountId) return children;
        } catch (_) {}
    }

    return (
        <Navigate
            to={
                lang
                    ? `/${lang}${accountRoutes.LOGIN}`
                    : addLangPrefix(accountRoutes.LOGIN)
            }
            state={{ from: location.pathname + location.search }}
            replace
        />
    );
};
